<template>
    <div class="flex-level">
        <div
            v-if="color != ''"
            class="chip label-chip"
            :class="[gapMapping]"
            :style="{'backgroundColor': `${color}`}">
        </div>
        <div class="flex label-value" v-html="label"></div>
    </div>
</template>

<script>
    export default {
        props: {
            color: {
                type: String,
                required: false,
                default: 'ddd'
            },
            label: {
                type: String,
                required: false,
                default: 'N/C'
            },
            gap: {
                validator: function (value) {
                    // The value passed must be one of these strings
                    return ['small', 'medium', 'large'].indexOf(value) !== -1
                },
                required: false,
                default: 'medium'         
            }
        },
        computed: {
            /**
             * Return the conversion of the gap to a class
             */
            gapMapping() {
                const map = {
                    small : 'mr-1',
                    medium: 'mr-2',
                    large : 'mr-3'
                }
                return map[this.gap];
            }
        }
    }
</script>